module.exports = __webpack_public_path__ + "img/cloud-yellow.3079b1ce.png";